// extracted by mini-css-extract-plugin
export default {"List":"ProfileMenuList_List__shmdk","Item":"ProfileMenuList_Item__my08d","ItemIcon":"ProfileMenuList_ItemIcon__TGYhq","ItemLabel":"ProfileMenuList_ItemLabel__3JhRc"};